import { ButtonPrimary } from "components/Atoms/Button";
import Modal from "components/modal";
import React, { useEffect } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { NewPlanningOptions } from "./types";
import { serializeToQueryString } from "utilities/queryString";
import { useOpenNewGroundSidePanel } from "components/SidePanel/GroundTransport/NewGroundSidePanel";
import { useOpenNewFlightSidePanel } from "components/SidePanel/Flight/NewFlightSidePanel";

interface Props {
  onClose: () => void
  isOpen: boolean
  options: NewPlanningOptions | null
}

export const NewPlanningModal = (props: Props) => {
  const openNewGroundTransportSidePanel = useOpenNewGroundSidePanel();
  const openNewFlightSidePanel = useOpenNewFlightSidePanel();

  useEffect(() => {
    if (props.isOpen && canOnlyAddShow()) {
      window.location.href = getNewShowRoute(props.options);
    }
  }, [props.isOpen]);

  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    displayHeader={false}
    gap="small"
  >
    {site.permissions.show.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={site.currentEnvironment.show.newLabel}
      href={getNewShowRoute(props.options)}
      iconLeft="icon-show"
      fluid
    />}
    {site.permissions.flight.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.Flight.NewFlight}
      onClick={() => {
        openNewFlightSidePanel();
        props.onClose();
      }}
      iconLeft="icon-flight"
      fluid
    />}
    {site.permissions.train.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.Train.NewTrainJourney}
      onClick={() => onNewTrain(props.options)}
      iconLeft="icon-train"
      fluid
    />}
    {site.permissions.groundTransport.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.GroundTransport.NewGroundTransport}
      onClick={() => {
        openNewGroundTransportSidePanel();
        props.onClose();
      }}
      iconLeft="icon-groundtransport"
      fluid
    />}
    {site.permissions.externalCalendar.canCreate && <ButtonPrimary
      style={{ justifyContent: "flex-start" }}
      label={RESX.ExternalCalendar.NewExternalCalendar}
      href={routes.externalCalendar_New().absolute}
      iconLeft="icon-external"
      fluid
    />}
    {site.debug && <div className="flex-column">
      <span>Debug options:</span>
      <div>{JSON.stringify(props.options, null, 2)}</div>
    </div>}
  </Modal>
}

const canOnlyAddShow = () => {
  return site.permissions.show.canCreate &&
    !site.permissions.flight.canCreate &&
    !site.permissions.train.canCreate &&
    !site.permissions.groundTransport.canCreate &&
    !site.permissions.externalCalendar.canCreate;
}

const getNewShowRoute = (options: NewPlanningOptions | null) => {
  const params = {
    date: options?.date ? options.date.toISOString() : null,
    artistId: options?.artist ? options.artist.artistId.toString() : null
  }
  const query = serializeToQueryString(params);

  return `${routes.show_New().absolute}?${query}`;
}

const onNewTrain = (options: NewPlanningOptions | null) => {
  const date = options?.date ? options.date.toDate() : null;

  const fromItem: server.dto.FromItem = {
    type: options?.fromShowId ? "show" : "none",
    id: options?.fromShowId ?? null
  }
  // TODO: We shouldn't use this
  SystemOneLibrary.exports.openModalAndCreateTrainJourney(date, options?.artist, fromItem);
}